/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import agentPic from "../../../assets/logos/ReviewAgentIcon.svg";
import userPic from "../../../assets/logos/People.svg";
import CheckIcon from "../../../assets/logos/Check.svg";
import BenefitAgentIcon from "../../../assets/logos/BenefitAgent.svg";
import SuggestedActions from "./SuggestedActions";
import { getAgentUI } from "../agents/agentUIConfig";
import MarkdownRenderer from "../MarkdownRenderer";
import ThinkingLoader from "../ThinkingLoader";

const KeyValueRenderer = ({ data }) => {
  if (data === null) return <em>null</em>;
  if (data === undefined) return <em>undefined</em>;

  if (Array.isArray(data)) {
    return (
      <ul className="kv-array">
        {data.map((item, idx) => (
          <li key={idx}>
            <KeyValueRenderer data={item} />
          </li>
        ))}
      </ul>
    );
  }

  if (typeof data === "object") {
    return (
      <ul className="kv-object">
        {Object.entries(data).map(([key, value]) => (
          <li key={key}>
            <strong>
              {key}
              :
            </strong>
            {" "}
            <KeyValueRenderer data={value} />
          </li>
        ))}
      </ul>
    );
  }

  return <span>{String(data)}</span>;
};

const ChatMessage = ({
  sender,
  text,
  tasks,
  showSuggestedActions,
  onRunDuplicateCheck,
  onSaveForLater,
  runDuplicateLabel,
  type,
  summary,
  matches,
  clusters,
  counts,
  outputText,
  agent,
  agentName,
  status,
  logedInUserMail,
}) => {
  const isUser = sender === "user";
  const navigate = useNavigate();
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRow = (caseId) => {
    setExpandedRow((prev) => (prev === caseId ? null : caseId));
  };

  const handleRunDuplicateCheck = () => {
    if (runDuplicateLabel === "View Report") {
      navigate("/duplicate-report");
    } else if (runDuplicateLabel === "Benefits Report") {
      navigate("/benefit-duplicate-report");
    } else {
      onRunDuplicateCheck?.();
    }
  };

  const isDuplicateResult = type === "duplicate_result";
  const isRunSummary = type === "run_summary";
  const isError = type === "error";

  const SummaryRenderer = ({ summary }) => {
    if (!summary) return null;

    const lines = summary.split("\n");
    let currentList = [];
    const blocks = [];

    lines.forEach((line, i) => {
      const trimmed = line.trim();
      if (!trimmed) return;

      // Headings (not bullets)
      if (!trimmed.startsWith("-")) {
        if (currentList.length) {
          blocks.push(<ul key={`ul-${i}`}>{currentList}</ul>);
          currentList = [];
        }
        blocks.push(<h4 key={`h-${i}`}>{trimmed}</h4>);
      } else {
        currentList.push(
          <li key={`li-${i}`}>{trimmed.slice(1).trim()}</li>,
        );
      }
    });

    if (currentList.length) {
      blocks.push(<ul key="final-ul">{currentList}</ul>);
    }

    return <div className="summary">{blocks}</div>;
  };

  const getInitials = (email) => {
    if (!email) return "";

    const namePart = email.split("@")[0];
    const parts = namePart.split(/[._]/);

    const initials = parts.map((p) => p[0].toUpperCase()).join("");
    return initials;
  };

  const initials = getInitials(logedInUserMail);

  return (
    <div className={`chat-row ${isUser ? "right" : "left"}`}>
      {!isUser && (
        <img
          src={getAgentUI(agentName).icon}
          className="agent-avatar"
          alt={getAgentUI(agentName).label}
        />
      )}

      <div className="chat-content">
        <div className={`chat-bubble ${isUser ? "user-bubble" : "agent-bubble"}`}>

          {/* ================= TEXT ================= */}
          {text && <p><MarkdownRenderer content={text} /></p>}

          {/* ================= ERROR ================= */}
          {isError && (
            <p className="error-text">
              {<MarkdownRenderer content={summary} /> || `Something went wrong while contacting the Agent. Try again shortly.`}
            </p>
          )}

          {/* ================= RUN / FILTER SUMMARY ================= */}
          {isRunSummary && (
            <div className="run-summary">
              {/* {summary && <p>{summary}</p>} */}
              {summary && <MarkdownRenderer content={summary} />}

              {/* {counts && (
                <ul className="counts-list">
                  {Object.entries(counts).map(([key, value]) => (
                    <li key={key}>
                      <strong>
                        {key.replace(/_/g, " ")}
                        :
                      </strong>
                      {" "}
                      {value ?? "N/A"}
                    </li>
                  ))}
                </ul>
              )} */}
            </div>
          )}

          {/* ================= TASKS ================= */}
          {/* {tasks && (
            <ul className="task-list">
              {tasks.map((t, i) => (
                <li key={i} className={`list ${t.status}`}>
                  <span className="list-label">
                    {t.label}
                  </span>
                  <span className={`status ${t.status}`}>
                    {t.status === "done" ? "Done" : "In progress"}
                  </span>
                </li>
              ))}
            </ul>
          )} */}

          {/* ================= DUPLICATE TABLE ================= */}

          {isDuplicateResult && (
            <div className="duplicate-result-section">

              {/* {summary && <p>{summary}</p>} */}
              {summary && <MarkdownRenderer content={summary} />}

              {/* {counts && (
            <ul className="counts-list">
              {Object.entries(counts).map(([k, v]) => (
                <li key={k}>
                  <strong>
                    {k.replace(/_/g, " ")}
                    :
                  </strong>
                  {' '}
                  {v ?? "N/A"}
                </li>
              ))}
            </ul>
            )}

            {matches.length === 0 && (
            <p className="empty-state">No matching applications found.</p>
            )}

            {matches.length > 0 && (
            <div className="table-scroll">
              <div className="table-inner">
                <table className="duplicate-table">
                  <thead>
                    <tr>
                      <th>Details</th>
                      <th>Status</th>
                      <th>Case ID</th>
                      <th>Candidate</th>
                      <th>Similarity</th>
                      <th>Confidence</th>
                    </tr>
                  </thead>

                  <tbody>
                    {matches.map((m) => (
                      <React.Fragment key={m.case_id}>
                        <tr>
                          <td>
                            <button
                              type="button"
                              className="link-btn"
                              onClick={() => toggleRow(m.case_id)}
                            >
                              {expandedRow === m.case_id ? "Hide" : "View"}
                            </button>
                          </td>
                          <td>{m.status || "—"}</td>
                          <td>{m.case_id}</td>
                          <td>
                            <div className="candidate-cell">
                              {m.record?.full_candidate_record ? (
                                <KeyValueRenderer data={m.record.full_candidate_record} />
                              ) : (
                                "—"
                              )}
                            </div>

                          </td>

                          <td>
                            {m.final_similarity != null
                              ? `${(m.final_similarity * 100).toFixed(0)}%`
                              : "—"}
                          </td>
                          <td>
                            {m.confidence != null ? `${m.confidence}%` : "—"}
                          </td>
                        </tr>

                        {expandedRow === m.case_id && (
                        <tr className="details-row">
                          <td colSpan={6}>
                            <h5>Field Scores</h5>
                            <ul>
                              {Object.entries(m.field_scores || {}).map(
                                ([k, v]) => (
                                  <li key={k}>
                                    {k}
                                    :
                                    {" "}
                                    {v != null
                                      ? `${(v * 100).toFixed(0)}%`
                                      : "N/A"}
                                  </li>
                                ),
                              )}
                            </ul>

                            {m.reasons?.length > 0 && (
                            <>
                              <h5>Reasons</h5>
                              <ul>
                                {m.reasons.map((r, i) => (
                                  <li key={i}>
                                    <strong>
                                      {r.field}
                                      :
                                    </strong>
                                    {" "}
                                    {r.note}
                                    {' '}
                                    (
                                    {r.score != null
                                      ? `${(r.score * 100).toFixed(0)}%`
                                      : "N/A"}
                                    )
                                  </li>
                                ))}
                              </ul>
                            </>
                            )}
                          </td>
                        </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            )} */}

            </div>
          )}

          {/* ================= CLUSTERS ================= */}

          {type === "cluster" && (
            <div className="cluster-section">

              {/* {summary && <p>{summary}</p>} */}
              {summary && <MarkdownRenderer content={summary} />}

              {/* {clusters.length === 0 && (
            <p className="empty-state">No clusters found.</p>
            )}

            {clusters.map((c) => (
              <div key={c.cluster_id} className="cluster-card">
                {clusters.map((c) => (
                  <div key={c.cluster_id} className="cluster-card">
                    <p>
                      <strong>Cluster ID:</strong>
                      {' '}
                      {c.cluster_id}
                    </p>
                    <p>
                      <strong>Primary Case:</strong>
                      {' '}
                      {c.primary_case_id}
                    </p>
                    <p>
                      <strong>Size:</strong>
                      {' '}
                      {c.size}
                    </p>
                    <p>
                      <strong>Confidence:</strong>
                      {" "}
                      {c.confidence != null
                        ? `${(c.confidence * 100).toFixed(0)}%`
                        : "N/A"}
                    </p>

                    <p><strong>Cases:</strong></p>
                    <ul>
                      {c.case_ids?.map((id) => (
                        <li key={id}>{id}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ))} */}
            </div>
          )}

          {/* ================= RAW RESPONSE (ALWAYS SAFE) ================= */}
          {outputText && !isError && (
            <details className="raw-response">
              <summary>View full response data</summary>
              <KeyValueRenderer data={outputText} />
            </details>
          )}
           {/* AGENT thinking state */}
        {!isUser && status === "thinking" && (
          // <div className="sent-status agent-sent-status" style={{width:"100%"}}>
          //   {/* Thinking... */}
          //   {/* <Lottie animationData={thinkingLoader} loop={true} /> */}
          // </div>
            <div>
            <ThinkingLoader size={10}/>
            </div>
        )}

        </div>

        {/* USER always shows sent */}
        {isUser && (
          <div className="sent-status user-sent-status">
            <img src={CheckIcon} alt="sent" />
            sent
          </div>
        )}

        {/* AGENT shows sent only when complete */}
        {!isUser && status?.trim()?.toLowerCase() === "complete" && (
          <div className="sent-status agent-sent-status">
            <img src={CheckIcon} alt="sent" />
            sent
          </div>
        )}

        {/* AGENT thinking state */}
        {/* {!isUser && status === "thinking" && (
            <div>
            <ThinkingLoader size={8} color="red" />
            </div>
        )} */}

        {/* ================= ACTIONS ================= */}
        {!isUser && showSuggestedActions && (
          <SuggestedActions
            applicationCount={tasks?.length || 0}
            onRunDuplicateCheck={handleRunDuplicateCheck}
            onSaveForLater={onSaveForLater}
            runDuplicateLabel={runDuplicateLabel}
          />
        )}
      </div>
      {/* ================= USER STATUS ================= */}
      {isUser && (
        <>
          {/* <img src={userPic} className="user-avatar" alt="User" /> */}
          <div className="user-content-feed">
            <div className="user-initials">
              <span>{initials}</span>
            </div>
          </div>

        </>
      )}
    </div>
  );
};

export default ChatMessage;
